module.exports = __webpack_public_path__ + "images/gadget/ui-icons_222222_256x240.png";